var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldHalfFill = function SvgShieldHalfFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shield-half-fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M19.596 11.493c0 5.046-3.413 9.765-7.998 10.91C7.012 21.259 3.6 16.54 3.6 11.494V6.68a1 1 0 0 1 .586-.91l6.998-3.183a1 1 0 0 1 .828 0L19.01 5.77a1 1 0 0 1 .586.91zm-7.998 9.092c3.332-.909 6.22-4.964 6.22-8.892V7.219l-6.22-2.837z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shield-half-fill_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgShieldHalfFill;